const registrationPatterns = [
  new RegExp(/\b[A-Z]{2}([1-9]|0[2-9]|6[0-9]|1[0-9])[A-Z]{3}\b/i), // current series
  new RegExp(/\b[A-HJ-NP-Y]\d{1,3}[A-Z]{3}\b/), // previous series
  new RegExp(/\b[A-Z]{3}\d{1,3}[A-HJ-NP-Y]\b/), // previous series
  new RegExp(/\b(?:[A-Z]{1,2}\d{1,4}|[A-Z]{3}\d{1,3})\b/), // old series - letters first
  new RegExp(/\b(?:\d{1,4}[A-Z]{1,2}|\d{1,3}[A-Z]{3})\b/), // old series - digits first
  new RegExp(/\b[A-Z]{2,3}\d{1,4}/), // Northern Ireland,
  new RegExp(
    /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}[A-Z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)/
  ), // https://gist.github.com/danielrbradley/7567269
];

export const numberLetterPattern = /^[a-zA-Z0-9\s]{0,10}$/;

export const validateRegistration = (registration: string) => {
  const clearRegistration = removeWhiteSpaces(registration).toUpperCase();
  return registrationPatterns.some((pattern) =>
    pattern.test(clearRegistration)
  );
};

export const removeWhiteSpaces = (str: string) => str.replace(/\s+/g, "");
